// https://vuex.vuejs.org/en/mutations.html

export default {
  auth_request (state) {
    state.authStatus = 'loading'
  },
  auth_success (state, { token, user, username, roluser, rolesuser, lstrodid, permisos, vencimiento, foto, idestado, iddelegacion, mensaje }) {
    state.authStatus = 'success'
    state.token = token
    state.user = user
    state.username = username
    state.rolusuario = roluser
    state.rolesusuario = rolesuser
    state.rolesid= lstrodid
    state.permisos = permisos
    state.vencimiento = vencimiento
    state.foto = foto
    state.idestado = idestado
    state.iddelegacion= iddelegacion
    state.mensaje=mensaje
  },
  auth_error (state, mensaje) {
    state.authStatus = 'error'
    state.token = ''
    state.user = ''
    state.username = ''
    state.rolusuario = 0
    state.rolesusuario = null
    state.rolesid = null
    state.permisos = null
    state.vencimiento = null
    state.foto = ''
    state.idestado = 0
    state.iddelegacion= 0
    state.mensaje= mensaje
  },
  logout (state) {
    state.authStatus = ''
    state.token = ''
    state.user = ''
    state.username = ''
    state.rolusuario = 0
    state.rolesusuario = null
    state.rolesid = null
    state.permisos = null
    state.vencimiento = null
    state.foto = ''
    state.idestado = 0
    state.iddelegacion= 0
    state.mensaje=''
  }
  ,setTableList (state, tableList) {
    state.tableList = tableList
  }
}
